import { useSearchParams } from "react-router-dom";
import { EyeIcon, EyeSlashIcon } from "@heroicons/react/24/outline";

import { useFirebase } from "firebase";

const PARAM = "view-as-customer";

export default function ViewAsCustomerToggle() {
  const { user } = useFirebase();
  const [searchParams, setSearchParams] = useSearchParams();

  const isAfterStaff = !!user?.email?.endsWith("@after.com");
  if (!isAfterStaff) return null;

  const isViewingAsCustomer = searchParams.has(PARAM);

  const toggle = () => {
    const next = new URLSearchParams(searchParams);
    if (isViewingAsCustomer) {
      next.delete(PARAM);
    } else {
      next.set(PARAM, "");
    }
    setSearchParams(next, { replace: true });
  };

  const Icon = isViewingAsCustomer ? EyeSlashIcon : EyeIcon;
  const label = isViewingAsCustomer ? "Exit customer view" : "View as customer";

  return (
    <button
      type="button"
      onClick={toggle}
      className="fixed bottom-4 right-4 z-50 flex items-center gap-2 rounded-full bg-evergreen px-4 py-2 text-sm font-medium text-ivory shadow-lg hover:bg-evergreen/90 focus:outline-none focus:ring-2 focus:ring-evergreen focus:ring-offset-2"
      aria-label={label}
      aria-pressed={isViewingAsCustomer}
    >
      <Icon className="h-5 w-5" />
      {label}
    </button>
  );
}
